// src/components/ui/card.jsx
import React from 'react'

const baseCard = 'flex h-full flex-col rounded-xl border border-zinc-200/80 bg-white/90 shadow-sm transition-shadow hover:shadow-md dark:border-white/[0.07] dark:bg-white/[0.04]'

export function Card({ children, className = '', ...props }) {
  return (
    <div className={`${baseCard} ${className}`} {...props}>
      {children}
    </div>
  )
}

export function CardHeader({ children, className = '' }) {
  return <div className={`flex items-start justify-between gap-3 p-5 pb-0 ${className}`}>{children}</div>
}

export function CardContent({ children, className = '' }) {
  return <div className={`flex flex-col gap-3 p-5 ${className}`}>{children}</div>
}

export function CardFooter({ children, className = '' }) {
  return <div className={`mt-auto border-t border-zinc-100 p-5 pt-4 dark:border-white/[0.06] ${className}`}>{children}</div>
}
